module.exports = __webpack_public_path__ + "static/media/credit-card_paypal.f6f6e09a.svg";